import React from 'react';
import About_discraption from '../Component/About_discraption'
import Company_staff from '../Component/Company_staff'
import About_poster from '../Component/About_poster'
import Strengths_comp from '../Component/Strengths_comp'
import Our_vision from '../Component/Our_vision'
import { Helmet } from 'react-helmet-async';
import Total_Count from '../Component/Total_Count';
import All_Program_Mentor from '../Component/All_Program_Mentor'
function About_us() {

  const canonicalUrl = 'https://www.internselite.net/About-Internselite';

  // useEffect(()=>{
  //   document.title='About Us | InternsElite';
  // },[]);
  return (
    <>
    <Helmet>
        <title>About InternsElite: Leading Online Internships & Professional Courses</title>
        <meta name='description' content='Discover InternsElite, your gateway to professional growth with top-notch online internships and professional courses. We offer comprehensive training programs in Machine Learning, AI, Web Development, and more, with certification and placement support. Learn from industry experts and gain practical skills to excel in your career.' />
        <meta name='keywords' content='online internships, professional courses, certification courses, IIT online courses, virtual internship, online training' />
        <meta property="og:title" content="About InternsElite: Leading Online Internships & Professional Courses" />
        <meta property="og:description" content="Discover InternsElite, your gateway to professional growth with top-notch online internships and professional courses. We offer comprehensive training programs in Machine Learning, AI, Web Development, and more, with certification and placement support. Learn from industry experts and gain practical skills to excel in your career." />
        <meta property="og:url" content="https://internselite.net/About-Internselite" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@internselite" />
        <meta name="twitter:title" content="About InternsElite: Leading Online Internships & Professional Courses" />
        <meta name="twitter:description" content="Discover InternsElite, your gateway to professional growth with top-notch online internships and professional courses. We offer comprehensive training programs in Machine Learning, AI, Web Development, and more, with certification and placement support. Learn from industry experts and gain practical skills to excel in your career." />
        <meta name="twitter:image" content="https://internselite.net/static/media/logo.c1eb8ff81ef75599f376.png" />
        <link rel="canonical" href={canonicalUrl} />
    </Helmet>
    <About_poster/>
    <About_discraption/>
    <Our_vision/>
    <Strengths_comp/>
    <Company_staff/>
    < All_Program_Mentor/>
    <div className='mb-5'><Total_Count/></div>
    </>
  )
}

export default About_us
